/* see docs for explanation of keys: https://support.google.com/analytics/answer/1033068?hl=en&utm_id=ad */
export default {
  methods: {
    trackSignup() {
      this.$ma.trackEvent({
        category: 'Sign up',
        action: 'ButtonClick - Sign up',
        label: 'page',
        value: 1
      })
    },

    trackExploreApi() {
      this.$ma.trackEvent({
        category: 'Documentation',
        action: 'ButtonClick - Explore API',
        label: 'page',
        value: 1
      })
    },

    trackContactUs() {
      this.$ma.trackEvent({
        category: 'Email',
        action: 'ButtonClick - Contact Us',
        label: 'page',
        value: 1
      })
    }
  }
}
